import { FolderManageAccessProvider } from './FolderManageAccessContext';
import { FolderManageAccessModalBody } from './FolderManageAccessModalBody';

type FolderManageAccessModal = {
  organizationId: string;
  workspaceId: string;
  folderId: string;
  onClose: () => void;
  isOpen?: boolean;
};

export const FolderManageAccessModal = ({
  organizationId,
  folderId,
  workspaceId,
  onClose,
  isOpen,
}: FolderManageAccessModal) => {
  return (
    <FolderManageAccessProvider
      folderId={folderId}
      workspaceId={workspaceId}
      organizationId={organizationId}
      isOpen={isOpen}
      onClose={onClose}
    >
      <FolderManageAccessModalBody />
    </FolderManageAccessProvider>
  );
};
